const DocHub = () => import(/* webpackChunkName: "admin_doc_hub" */ '@/components/admin/DocHub')
const Index = () => import(/* webpackChunkName: "admin_doc_hub" */ '@/components/admin/doc-hub/Index')
const Event = () => import(/* webpackChunkName: "admin_doc_hub" */ '@/components/admin/doc-hub/Event')
const Order = () => import(/* webpackChunkName: "admin_doc_hub" */ '@/components/admin/doc-hub/Order')
const Item = () => import(/* webpackChunkName: "admin_doc_hub" */ '@/components/admin/doc-hub/Item')

export default {
  children: [
    {
      component: Index,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {name: 'Doc Hub'},
        ]
      },
      path: '/',
    },
    {
      component: Event,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/doc-hub', name: 'Doc Hub'},
          {name: 'Eventos'},
        ]
      },
      path: 'events'
    },
    {
      component: Order,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/doc-hub', name: 'Doc Hub'},
          {name: 'Orders'},
        ]
      },
      path: 'orders'
    },
    {
      component: Item,
      meta: {
        breadcrumbs: [
          {link: '/admin', name: 'Administração'},
          {link: '/admin/doc-hub', name: 'Doc Hub'},
          {name: 'Items'},
        ]
      },
      path: 'items'
    },
  ],
  component: DocHub,
  path: 'doc-hub'
}
